import { DeviceDefinitionSummaryModel } from '../deviceDefinitionSummary.model';
import { Injectable } from '@angular/core';
import { PermissionsConverter } from "src/app/modules/common/converter/permissions.converter";
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {LovValueSummaryConverter} from "../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
  providedIn: 'root'
})
export class DeviceDefinitionSummaryConverter extends HttpModelConverter<DeviceDefinitionSummaryModel> {
  constructor(private permissionConverter: PermissionsConverter,
              private lovValueSummaryConverter: LovValueSummaryConverter) {
    super();
  }

  protected createInstance(): DeviceDefinitionSummaryModel {
    return new DeviceDefinitionSummaryModel();
  }

  protected enrichObject(result: DeviceDefinitionSummaryModel, src: DeviceDefinitionSummaryModel) {
    result.permissions = this.permissionConverter.convert(src.permissions);
    result.type = this.lovValueSummaryConverter.convert(result.type);
  }
}

